import { Typography } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Popover from "@material-ui/core/Popover";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { makeStyles } from "@material-ui/styles";
import ContentTitle from "components/common/ContentTitle";
import EditButton from "components/common/EditButton";
import InfoIconButton from "components/common/InfoIconButton";
import { STATUS_PROCESS } from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { getRouterChangeSmartByConditionType } from "libs/utils/changeSmart";
import { formatDate } from "libs/utils/format";
import { get } from "lodash-es";
import mime from "mime";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getPersonalDetail } from "redux/modules/personalSlice";
import { initRouter, setSmartFormStep } from "redux/modules/uiSlice";
import {
  currentDocumentSlice,
  getListSmartForm,
  getSmartForm,
  selectCurrentDocument,
  selectCurrentSmartForm,
  selectListSmartForm,
} from "redux/modules/visaForm";
import AllDocumentsService from "services/AllDocumentsService";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#f1f3f9",
    color: "#172b4d",
    fontSize: 16,
    padding: "0px 16px",
  },
  body: {
    fontSize: 16,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: 0,
    paddingBottom: 124,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  table: {
    minWidth: 700,
    "& .MuiTableCell-root": {
      borderLeft: "0px solid rgba(224, 224, 224, 1)",
      borderRight: "0px solid rgba(224, 224, 224, 1)",
      height: 40,
    },
  },
  tableTitle: {
    color: "#8898aa",
    marginLeft: 16,
  },
  badge: {
    display: "flex",
    width: 12,
    height: 12,
    borderRadius: 12,
    backgroundColor: "#feb969",
    marginRight: 12,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  badgeSuccess: {
    display: "flex",
    width: 12,
    height: 12,
    borderRadius: 12,
    backgroundColor: "#2DCE98",
    marginRight: 12,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
  listRoot: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  popover2: {
    // pointerEvents: 'none',
  },
  popoverContent2: {
    // pointerEvents: 'auto',
  },
}));

export default function DocumentList() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { hideLoading, showLoading } = useModalLoading();
  const listSmartFormState = useSelector(selectListSmartForm);
  const currentDocumentState = useSelector(selectCurrentDocument);
  const smartForm = useSelector(selectCurrentSmartForm);

  const typeDocSmartFromID = get(smartForm, "typeDocSmartFromID", "");
  const statausID = get(smartForm, "statausID", "");

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const detail = get(smartForm, "detail", []).reduce(smartNameById, {});
  const ConditionType = get(detail, "ConditionType.value", "");

  const [anchorEl, setAnchorEl] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);

  const [openedPopoverId, setOpenedPopoverId] = useState(null);
  const [anchorElDetail, setAnchorElDetail] = useState(null);
  const handlePopoverOpen = (index) => (event) => {
    setOpenIndex(index);
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setOpenIndex(null);
    setAnchorEl(null);
  };

  const open = openIndex;

  const openDetail = Boolean(anchorElDetail);

  useEffect(() => {
    dispatch(getListSmartForm());
  }, [dispatch]);

  useEffect(() => {
    if (currentDocumentState.isSuccess || currentDocumentState.isFailure) {
      hideLoading();
      if (currentDocumentState.isSuccess) {
        dispatch(currentDocumentSlice.actions.clearAsyncState());
        // TODO wait for check 5 smart
        if (statausID === STATUS_PROCESS.RequestAddDoc) {
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        } else if (typeDocSmartFromID === "E") {
          dispatch(setSmartFormStep(SMART_T_STEP.PART_A_1));
        } else if (typeDocSmartFromID === "C") {
          dispatch(
            setSmartFormStep(
              getRouterChangeSmartByConditionType(ConditionType)[1]
            )
          );
        } else {
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
        }
      }
    }
  }, [
    currentDocumentState,
    dispatch,
    hideLoading,
    typeDocSmartFromID,
    ConditionType,
  ]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Reject":
        return "#ED1C24";
      case "Completed":
        return "#2DCE98";
      case "Draft":
        return "#B0B6BA";
      case "Pending":
      default:
        return "#feb969";
    }
  };

  return (
    <div className={classes.root}>
      <ContentTitle
        title="Check Status"
        subTitle="Number of successful applicants by targeted industries"
        hideLine
      />
      <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell>
                <Typography variant="h6" className={classes.tableTitle}>
                  DATE
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="h6" className={classes.tableTitle}>
                  DOC No.
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="h6" className={classes.tableTitle}>
                  TYPE
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="h6" className={classes.tableTitle}>
                  STAFF NAME
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="h6" className={classes.tableTitle}>
                  STATUS
                </Typography>
              </StyledTableCell>
              <StyledTableCell align="center">
                <Typography variant="h6" className={classes.tableTitle}>
                  ACTION
                </Typography>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listSmartFormState.data.map((data, index) => (
              <TableRow key={data.draftId}>
                <StyledTableCell>
                  <Typography>
                    {formatDate(data.smartDate, "DD MMM YYYY")}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography>{data.smartNo || "-"}</Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography>{data.typeDocSmartFromName || "-"}</Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography>{data.staffname || "-"}</Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    className={classes.flexRow}
                    aria-owns={open ? `mouse-over-popover-${index}` : undefined}
                    aria-haspopup="true"
                    onMouseEnter={handlePopoverOpen(index)}
                    onMouseLeave={handlePopoverClose}
                  >
                    <div
                      className={classes.badgeSuccess}
                      style={{
                        backgroundColor: getStatusColor(data.statusDocName),
                      }}
                    />
                    <Typography>{data.statusDocName}</Typography>
                  </div>
                  <Popover
                    id={`mouse-over-popover-${index}`}
                    className={classes.popover}
                    classes={{
                      paper: classes.paper,
                    }}
                    elevation={2}
                    open={open === index}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    onClose={handlePopoverClose}
                    disableRestoreFocus
                  >
                    <div className={classes.listRoot}>
                      <List component="nav">
                        <ListItem button>
                          <ListItemText primary="Organization" />
                        </ListItem>
                      </List>
                      <Divider />
                      <List component="nav">
                        {data.configApprveSmartFrom.map((ap) => (
                          <ListItem button key={ap.departmentId}>
                            <ListItemIcon>
                              {ap.statusProcessName === "Completed" ? (
                                <CheckCircleIcon style={{ color: "#2DCE98" }} />
                              ) : (
                                <RemoveCircleIcon
                                  style={{ color: "#FEB969", marginLeft: 0 }}
                                />
                              )}
                            </ListItemIcon>
                            <ListItemText primary={ap.departmentName} />
                          </ListItem>
                        ))}
                      </List>
                    </div>
                  </Popover>
                </StyledTableCell>
                <StyledTableCell align="right">
                  <div
                    className={classes.flexRow}
                    style={{ justifyContent: "flex-end" }}
                  >
                    <EditButton
                      title="View"
                      onClick={async () => {
                        showLoading();

                        if (
                          data.typeDocSmartFromName === "Request" ||
                          data.typeDocSmartFromName === "Extension"
                        ) {
                          if (
                            data.statusDocId === STATUS_PROCESS.RequestAddDoc
                          ) {
                            dispatch(
                              initRouter([
                                SMART_T_STEP.NONE,
                                SMART_T_STEP.UPLOAD_DOCUMENT,
                              ])
                            );

                            await dispatch(
                              getPersonalDetail({ personalId: data.personalId })
                            );
                            await dispatch(
                              getSmartForm({
                                personalId: data.personalId,
                                draftId: data.draftId,
                              })
                            );

                            hideLoading();
                            dispatch(
                              setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT)
                            );
                            return;
                          }

                          dispatch(
                            initRouter([
                              SMART_T_STEP.NONE,
                              SMART_T_STEP.UPLOAD_PASSPORT,
                              SMART_T_STEP.PART_A_1,
                              SMART_T_STEP.PART_A_2,
                              SMART_T_STEP.UPLOAD_DOCUMENT,
                            ])
                          );

                          await dispatch(
                            getPersonalDetail({ personalId: data.personalId })
                          );
                          await dispatch(
                            getSmartForm({
                              personalId: data.personalId,
                              draftId: data.draftId,
                            })
                          );

                          hideLoading();
                          dispatch(
                            setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT)
                          );
                        } else if (
                          data.typeDocSmartFromName === "Termination"
                        ) {
                          dispatch(
                            initRouter([
                              SMART_T_STEP.NONE,
                              SMART_T_STEP.UPLOAD_PASSPORT,
                              SMART_T_STEP.TERMINATION,
                            ])
                          );

                          await dispatch(
                            getPersonalDetail({ personalId: data.personalId })
                          );
                          await dispatch(
                            getSmartForm({
                              personalId: data.personalId,
                              draftId: data.draftId,
                            })
                          );

                          hideLoading();
                          dispatch(
                            setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT)
                          );
                        }
                      }}
                    />
                    <InfoIconButton
                      aria-describedby="mouse-over-detial-popover"
                      onClick={(event) => {
                        const hasSomeActionListMenu =
                          data?.statusDocId === STATUS_PROCESS.Complete ||
                          data?.statusDocId === STATUS_PROCESS.FinalApproved ||
                          data?.statusProcessId === STATUS_PROCESS.Draft ||
                          data?.statusProcessId === STATUS_PROCESS.Pending ||
                          data?.statusProcessId === STATUS_PROCESS.Processing ||
                          data?.statusProcessId === STATUS_PROCESS.RequestAddDoc ||
                          data?.statusProcessId === STATUS_PROCESS.UploadAddDoc;
                        if (hasSomeActionListMenu) {
                          setOpenedPopoverId(data.draftId);
                          setAnchorElDetail(event.currentTarget);
                        }
                      }}
                    />
                    <Popover
                      className={classes.popover2}
                      classes={{
                        paper: classes.popoverContent2,
                      }}
                      open={openDetail && openedPopoverId === data.draftId}
                      anchorEl={anchorElDetail}
                      onClose={() => {
                        setOpenedPopoverId(null);
                        setAnchorElDetail(null);
                      }}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                    >
                      {/* <Typography className={classes.typography}
                        onClick={(e) => {
                          console.log(data.draftId);
                        }}>The content of the Popover.</Typography> */}

                      <List component="nav">
                        <ListItem button>
                          <ListItemText
                            primary="Download"
                            onClick={async () => {
                              if (data.statusDocId === "C") {
                                const draftId = data.draftId;
                                const filename = draftId + ".pdf";
                                const blob =
                                  await AllDocumentsService.downloadDocDetail(
                                    draftId
                                  );
                                const blobFile = new File([blob], filename, {
                                  type: mime.getType(".pdf"),
                                });

                                window.open(
                                  URL.createObjectURL(blobFile),
                                  "_blank"
                                );

                                setOpenedPopoverId(null);
                                setAnchorElDetail(null);
                              }
                            }}
                          />
                        </ListItem>

                        {(data.statusDocId === STATUS_PROCESS.Complete ||
                          data.statusDocId === STATUS_PROCESS.FinalApproved) &&
                          data.typeDocSmartFromID === "T" && (
                            <ListItem button>
                              <ListItemText
                                primary="Download"
                                onClick={async () => {
                                  if (
                                    data.statusDocId ===
                                    STATUS_PROCESS.Complete ||
                                    data.statusDocId ===
                                    STATUS_PROCESS.FinalApproved
                                  ) {
                                    const draftId = data.draftId;
                                    const filename = draftId + ".pdf";
                                    const blob =
                                      await AllDocumentsService.downloadTerminate(
                                        draftId
                                      );
                                    const blobFile = new File(
                                      [blob],
                                      filename,
                                      {
                                        type: mime.getType(".pdf"),
                                      }
                                    );

                                    window.open(
                                      URL.createObjectURL(blobFile),
                                      "_blank"
                                    );

                                    setOpenedPopoverId(null);
                                    setAnchorElDetail(null);
                                  }
                                }}
                              />
                            </ListItem>
                          )}
                      </List>
                    </Popover>
                    {/* 
                    <div>
                      <Button aria-describedby="mouse-over-detial-popover" variant="contained" color="primary" onClick={(event) => {
                        setAnchorElDetail(event.currentTarget);
                      }}>
                        Open Popover
                      </Button>

                    </div> */}
                  </div>
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
